/* eslint-disable import/extensions */
import React from 'react';
import styled from './AuthError.styled';
import { LanguageProvider, Text } from '../../providers/LanguageProvider';

interface Props {
  error: string;
}

/**
 * Standalone screen rendered when authentication fails before the app shell mounts.
 * Renders outside Redux/Router, so it depends only on the language provider.
 */
const AuthError: React.FC<Props> = ({ error }) => (
  <LanguageProvider>
    <styled.Container>
      <styled.ErrorIcon iconName="Warning" />
      <styled.Title>
        <Text tid="AppErrorTitle" />
      </styled.Title>
      <styled.Details>{error}</styled.Details>
    </styled.Container>
  </LanguageProvider>
);

export default AuthError;
